const Svg = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M8.00016 1.33325C4.32016 1.33325 1.3335 4.31992 1.3335 7.99992C1.3335 11.6799 4.32016 14.6666 8.00016 14.6666C11.6802 14.6666 14.6668 11.6799 14.6668 7.99992C14.6668 4.31992 11.6802 1.33325 8.00016 1.33325ZM8.66683 11.3333H7.3335V7.33325H8.66683V11.3333ZM8.66683 5.99992H7.3335V4.66658H8.66683V5.99992Z"
        fill="black"
        fillOpacity="0.3"
      />
    </svg>
  );
};

export default Svg;
